@if (hasHeading) {
    <section
        class="hero-banner"
        [ngClass]="{
            'hero-banner--text-color-white': block.data.textColor === 'white',
            'hero-banner--text-color-black': block.data.textColor === 'black',
            'hero-banner--no-padding-y': block.data.removePaddingY,
            'hero-banner--include-divider-image': block.data.includeDividerImage,
            'hero-banner--layout-70-30': block.data.layout === 'split-70-30',
        }"
        [attr.data-overlay]="block.data.applyOverlay ? block.data.bgOverlay : null"
        [style.--hero-banner-desktop-height]="homeHeroBannerHeight"
        [style]="`--bg-image: ${getBackground()}; --bg-color: ${getBackgroundColor()}`">
        <!-- Content -->
        <div class="hero-banner__content">
            @if (hasHeading) {
                <ng-container *ngTemplateOutlet="headingTemplate"></ng-container>
            }

            @if (block.data.subheading) {
                <h2
                    class="hero-banner__subheading"
                    [ngClass]="{
                        'hero-banner__subheading--text-color-base': block.data.subheadingTextColor === 'base',
                        'hero-banner__subheading--text-color-primary': block.data.subheadingTextColor === 'primary',
                        'hero-banner__subheading--text-color-secondary': block.data.subheadingTextColor === 'secondary',
                        'hero-banner__subheading--text-color-heading': block.data.subheadingTextColor === 'heading',
                        'hero-banner__subheading--text-color-action': block.data.subheadingTextColor === 'action',
                        'hero-banner__subheading--text-size-small': block.data.subheadingTextSize === 'small',
                        'hero-banner__subheading--text-size-medium': block.data.subheadingTextSize === 'medium',
                        'hero-banner__subheading--text-size-large': block.data.subheadingTextSize === 'large',
                    }">
                    {{ block.data.subheading }}
                </h2>
            }

            @if (block.data.description) {
                <div class="hero-banner__description" [innerHTML]="block.data.description"></div>
            }

            @if (block.data.ctaLabel) {
                <a
                    class="btn btn-primary hero-banner__ctaLink"
                    [href]="block.data.ctaLink"
                    [target]="block.data.isCtaExternalLink ? '_target' : '_self'"
                    >{{ block.data.ctaLabel }}</a
                >
            }
        </div>

        <!-- Image -->
        @if (block.data.includeFgImage) {
            @if (block.data.layout === 'split-70-30') {
                <div
                    class="hero-banner__foreground-image-container"
                    [ngClass]="{
                        'hero-banner__foreground-image-container--is-full-bleed-right': block.data.isFullBleedRight,
                        'hero-banner__foreground-image-container--hide-on-mobile': block.data.hideImageOnMobile,
                        'hero-banner__foreground-image-container--hide-on-tablet': block.data.hideImageOnTablet,
                        'hero-banner__foreground-image-container--hide-on-small-desktop':
                            block.data.hideImageOnSmallDesktop,
                    }"
                    [style.--hero-banner-foreground-image-height]="block.data.fgImageHeight || null"
                    [style.--hero-banner-foreground-image-width]="block.data.fgImageWidth || null"
                    [style.--hero-banner-foreground-image-horizontal-alignment]="
                        block.data.fgImageHorizontalAlignment || null
                    "
                    [style.--hero-banner-foreground-image-vertical-alignment]="
                        block.data.fgImageVerticalAlignment || null
                    ">
                    <img
                        class="hero-banner__foreground-image"
                        [ngStyle]="{ 'object-fit': block.data.fgObjectFit || 'cover' }"
                        [src]="block.data.fgImage"
                        alt="" />
                </div>
            } @else {
                <img
                    class="hero-banner__foreground-image hero-banner__foreground-image--default"
                    [ngClass]="{
                        'hero-banner__foreground-image--is-full-bleed-right': block.data.isFullBleedRight,
                        'hero-banner__foreground-image--hide-on-mobile': block.data.hideImageOnMobile,
                        'hero-banner__foreground-image--hide-on-tablet': block.data.hideImageOnTablet,
                        'hero-banner__foreground-image--hide-on-small-desktop': block.data.hideImageOnSmallDesktop,
                    }"
                    [ngStyle]="{ 'object-fit': block.data.fgObjectFit || 'cover' }"
                    [src]="block.data.fgImage"
                    alt="" />
            }
        }
        @if (block.data.includeDividerImage) {
            <img class="hero-banner__divider-image" [src]="block.data.dividerImage" alt="" />
        }
    </section>
}

<ng-template #headingTemplate>
    @if (block.data.isStackedHeading) {
        <h1
            class="hero-banner__heading"
            [ngClass]="{
                'hero-banner__heading--text-color-base': block.data.headingTextColor === 'base',
                'hero-banner__heading--text-color-primary': block.data.headingTextColor === 'primary',
                'hero-banner__heading--text-color-secondary': block.data.headingTextColor === 'secondary',
                'hero-banner__heading--text-color-heading': block.data.headingTextColor === 'heading',
            }">
            <span
                class="hero-banner__heading-top"
                [ngClass]="{
                    'hero-banner__heading-top--text-style-outline': block.data.isHeadingTopOutlined,
                }"
                >{{ block.data.headingTop }}</span
            >
            <span
                class="hero-banner__heading-bottom"
                [ngClass]="{
                    'hero-banner__heading-bottom--text-style-outline': block.data.isHeadingBottomOutlined,
                }"
                >{{ block.data.headingBottom }}</span
            >
        </h1>
    } @else {
        <h1
            class="hero-banner__heading"
            [ngClass]="{
                'hero-banner__heading--text-color-base': block.data.headingTextColor === 'base',
                'hero-banner__heading--text-color-primary': block.data.headingTextColor === 'primary',
                'hero-banner__heading--text-color-secondary': block.data.headingTextColor === 'secondary',
                'hero-banner__heading--text-color-heading': block.data.headingTextColor === 'heading',
            }"
            [style.margin-bottom]="block.data.headingMarginBottom"
            [style]="block.data.useInheritFontSize ? 'font-size: var(--h1-font-size);' : ''">
            {{ block.data.heading }}
        </h1>
    }
</ng-template>
